import type {
  ApiEnvironment,
  ApiUser,
} from '#/api/userEnvironment/types/ApiUserEnvironment';
import type { AppConfig } from '#/config/types/AppConfig';

type Props = {
  user: ApiUser | null;
  environment: ApiEnvironment;
  appConfig: AppConfig;
};

export function HorizonSetIdealistObjectScript({
  user,
  environment,
  appConfig,
}: Props) {
  const idealistObject = {
    debugXhr: appConfig.idealist.debugXhr,
    initUserEnvironment: { user, environment },
    config: appConfig,
  } satisfies typeof global.Idealist;

  return (
    <script
      dangerouslySetInnerHTML={{
        __html: [
          `window.Idealist = ${JSON.stringify(idealistObject)};`,
          'window.dataLayer = window.dataLayer || [];',
          appConfig.idealist.debugXhr && `window.Idealist.debugXhr = true;`,
        ]
          .filter(Boolean)
          .join(''),
      }}
    />
  );
}
